export interface EnvironmentGroup {
  id?: number;
  name?: string;
  state?: string;
}
